module.exports = __webpack_public_path__ + "img/chaos_citadel_small.d8f4028d.png";